import { DeleteTreeNode } from '../../services/flowBuilder/models';
import { animate, state, style, transition, trigger } from '@angular/animations';
import {
  Component,
  EventEmitter,
  Input, OnInit,
  Output,
  SimpleChanges,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { stepLocation } from '../../services/flowBuilder/utils/locaction-calculator-interface';
import { MatMenu } from '@angular/material/menu';
import { OnChanges } from '@angular/core';
import { ArrayDataSource } from '@angular/cdk/collections';
import { FlatTreeControl } from '@angular/cdk/tree';
import { MatDialog } from '@angular/material/dialog';
import { NodeEmitter } from '../flow-node/flow-node.component';
import { FlowBuilderService } from '../../services/flowBuilder/flow-builder.service';
import { FlowManagerService } from '../../services/flow-manager.service';
import { SharedService } from '../../../../core/services/store/shared-store/shared-storage.service';
import {Observable} from "rxjs";
import {NodeObject} from "../../../../shared/utils/nodeTypes";
import {Store} from "@ngrx/store";
import {selectNodeTypesMap} from "../../../../core/state/selectors/flow.selector";
import {tap} from "rxjs/operators";

@Component({
  selector: 'recycle-bin',
  templateUrl: './recycle-bin.component.html',
  styleUrls: ['./recycle-bin.component.scss'],
  animations: [
    trigger('tabState', [
      state(
        'default',
        style({
          transform: 'translateY(0)',
        })
      ),
      state(
        'open',
        style({
          bottom: '0',
        })
      ),
      state(
        'max-open',
        style({
          height: 'calc(100vh - 49px)',
          bottom: '0',
        })
      ),
      state(
        'close',
        style({
          bottom: 'initial',
          top: '0',
        })
      ),
      transition('default <=> open', animate(500)),
      transition('open <=> max-open', animate(500)),
      transition('close <=> max-open', animate(500)),
      transition('default <=> max-open', animate(500)),
      transition('close <=> open', animate(500)),
    ]),
    trigger('rotatedState', [
      state('default', style({ transform: 'rotate(0)' })),
      state('rotated', style({ transform: 'rotate(-180deg)' })),
    ]),
    trigger('tabContainerState', [
      state(
        'default',
        style({
          transform: 'translateY(0)',
        })
      ),
      state(
        'open',
        style({
          bottom: '0',
          overflow: 'auto',
        })
      ),
      state(
        'max-open',
        style({
          height: 'calc(100vh - 49px)',
          bottom: '0',
          overflow: 'auto',
        })
      ),
      state(
        'close',
        style({
          bottom: 'initial',
          top: '0',
        })
      ),
    ]),
  ],
})
export class RecycleBinComponent implements OnChanges, OnInit {
  constructor(
    public dialog: MatDialog,
    public flowBuilderService: FlowBuilderService,
    public sharedService: SharedService,
    public flowService: FlowManagerService,
    private store: Store
  ) {}

  treeControl = new FlatTreeControl<DeleteTreeNode>(
    (node) => node.level,
    (node) => node.expandable
  );
  recycleBinClearNodesDialogRef;

  @ViewChild('recycleBinClearNodesDialog', { static: true }) recycleBinClearNodesDialog: TemplateRef<any>;
  @Input() deletedSteps: DeleteTreeNode[];
  @Input() matMenu: MatMenu;

  @Output() nodeSelected = new EventEmitter<NodeEmitter>();
  @Output() refreshRightSideBar = new EventEmitter<NodeEmitter>();

  panelOpenState = false;
  isDraggable: Boolean = true;
  @ViewChild('img') image: any;
  @ViewChild('newImg') newImage: any;

  nodeIcons$: Observable<any>;

  dataSource: ArrayDataSource<any>;

  state = 'default';
  rotateState = 'default';
  tabContainerState = 'default';
  selectedNodes: string[] = [];
  countNodes = 0;

  ngOnInit() {
    this.nodeIcons$ = this.store.select(selectNodeTypesMap).pipe(
        tap((node) => {
          for (const nodeType in node) {
            const url  = this.getIconBg(nodeType);
            this.flowService.cacheUrls = [url];
            this.flowService.getIndex(url);
          }
        })
    )
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.deletedSteps) {
      this.dataSource = new ArrayDataSource(this.deletedSteps);
    }
    this.selectedNodes = [];
  }

  openRecycleBin() {
    this.tabContainerState === 'default'
      ? (this.tabContainerState = 'open')
      : (this.tabContainerState = 'default');
    this.rotateState = 'default';
    this.state === 'default' ? (this.state = 'open') : (this.state = 'default');
  }

  closeRecycleBin() {
    this.tabContainerState === 'default'
      ? (this.tabContainerState = 'close')
      : (this.tabContainerState = 'default');
    this.rotateState = 'default';
    this.state === 'default' ? (this.state = 'close') : (this.state = 'default');
    this.selectedNodes = [];
  }

  expandRecyleBin() {
    this.rotateState = this.rotateState === 'default' ? 'rotated' : 'default';
    if (this.rotateState === 'rotated') {
      this.tabContainerState = 'max-open';
      this.state = 'max-open';
    } else {
      this.tabContainerState = 'open';
      this.state = 'open';
    }
  }

  nodeClick(treeNode: DeleteTreeNode, event: any) {
    if (event.shiftKey) {
      this.refreshRightSideBar.emit();
      this.isDraggable = false;
      if (this.selectedNodes.includes(treeNode.step.stepNumber)) {
        // const index = this.selectedNodes.indexOf(treeNode.step.stepNumber);
        // delete this.selectedNodes[index];
        this.selectedNodes = this.selectedNodes.filter((id) => id !== treeNode.step.stepNumber);
        return;
      }
      this.selectedNodes.push(treeNode.step.stepNumber);
    } else {
      this.isDraggable = true;
      const emitter: NodeEmitter = {
        stepId: treeNode.step.stepNumber,
        stepType: treeNode.step.stepType,
        nodeType: treeNode.step.nodeType,
        parentId: treeNode.step.parentId,
        extraFields: {}
      };

      this.selectedNodes = [treeNode.step.stepNumber];
      this.nodeSelected.emit(emitter);
    }
  }

  clearNodesClick() {
    this.flowBuilderService.clearSteps(this.selectedNodes);
    this.sharedService.setIsFlowChanged(true);
    this.refreshRightSideBar.emit();
    this.closeRecycleBinClearNodesDialog();
  }

  numSequence(n: number): Array<number> {
    return Array(n);
  }

  getDeletedStepsCount() {
    return this.deletedSteps ? Object.keys(this.deletedSteps).length : 0;
  }

  trackBy(index: any, step: stepLocation) {
    if (!step) {
      return null;
    }
    return step.nodeId;
  }

  closeRecycleBinClearNodesDialog(): void {
    this.recycleBinClearNodesDialogRef.close();
    this.selectedNodes = [];
  }

  openRecycleBinClearNodesDialog() {
    this.recycleBinClearNodesDialogRef = this.dialog.open(this.recycleBinClearNodesDialog, {
      panelClass: 'clickatellDialog',
      width: '442px',
      height: '299px',
      disableClose: true,
    });
  }

  hasChild = (_: number, node: DeleteTreeNode) => node.expandable;

  getParentNode(node: DeleteTreeNode) {
    const nodeIndex = this.deletedSteps.indexOf(node);

    for (let i = nodeIndex - 1; i >= 0; i--) {
      if (this.deletedSteps[i].level === node.level - 1) {
        return this.deletedSteps[i];
      }
    }

    return null;
  }

  shouldRender(node: DeleteTreeNode) {
    let parent = this.getParentNode(node);
    while (parent) {
      if (!parent.isExpanded) {
        return false;
      }
      parent = this.getParentNode(parent);
    }
    return true;
  }

  getIconBg(nodeType) {
    let baseUrl = '/assets/svg/redesign/nodes/';
    if (nodeType ==='chatHub'){
      return `/assets/svg/redesign/chathub.svg`;
    }
    return `${baseUrl}right-panel/${nodeType}.svg`;
  }

  findNodeType(srcElement) {
    const cloneElement = [...srcElement.childNodes];
    return [].filter
      .call(cloneElement, (element) => {
        return element.className === 'recycleBin_nodeType';
      })[0]
      .cloneNode(true);
  }

  async onDragStart(event, node, hasChild = false) {
    const { stepType, nodeType } = node.step;

    event.dataTransfer.setData('nodeType', nodeType);
    event.dataTransfer.setData('stepType', stepType);
    event.dataTransfer.setData('nodeData', JSON.stringify(node.step));
    event.dataTransfer.setData('hasChild', hasChild);

    this.loadImage(nodeType);
    const img: any = document.createElement('div');
    const imageSVG = await this.flowService.getIndex(this.getIconBg(nodeType));
    img.innerHTML = imageSVG.blob;
    img.className = 'drag-image';
    const elem: any = document.getElementById('drag-ghost');
    elem.innerHTML = '';

    if (hasChild) {
      const dragContainer: any = document.createElement('div');
      dragContainer.className = 'drag-container';

      const childrenCount = this.flowBuilderService.getChildrenCount(node.step.stepNumber);

      const dragText: any = document.createElement('p');
      dragText.className = 'drag-text';
      dragText.innerHTML = ` + ${childrenCount}`;

      dragContainer.appendChild(img);
      dragContainer.appendChild(dragText);
      elem.appendChild(dragContainer);

      event.dataTransfer.setDragImage(elem, 60, 30);
    } else {
      elem.appendChild(img);
      event.dataTransfer.setDragImage(elem, 38, 28);
    }

    setTimeout(() => {
      this.state = 'default';
    }, 500);
  }

  onDragEnd(e) {
    e.stopPropagation();
    setTimeout(() => {
      this.state = 'open';
    }, 500);
  }

  loadImage(nodeType: string) {
    const baseUrl = `/assets/svg/redesign/nodes/right-panel/${nodeType}.svg`;
    this.flowService.getIndex(baseUrl);
  }
}
